export enum AgentQuery {
    All = 'all',
    OnlyAvailable = 'onlyAvailable',
    OnlyAvailablePlusSuspended = 'onlyAvailablePlusSuspended'
}
